// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3f8r7","options":"AnswerScale_options__LmWQT","selected":"AnswerScale_selected__16EeR"};